/*
 * Whether the browse dialog is open, as a fact of the module rather than of one component.
 *
 * Two surfaces open the same dialog — the channel section's `+` menu and Home's *Browse channels*
 * action, which core draws from the `homeActions` slot and which hands over a plain callback with
 * no component to hold state in. So the flag lives here and the dialog is mounted once, by the
 * section's own controls; both doors set the same bit.
 */

import { Shared, useShared } from "../../../core/store/shared.ts"

const open = new Shared(false)

/** Opens the browse dialog from anywhere in the application; Home's action is a caller. */
export function requestBrowseChannels(): void {
	open.set(true)
}

/** The dialog's open state, for the one component that mounts it. */
export function useBrowseChannels(): { open: boolean; setOpen: (next: boolean) => void } {
	return { open: useShared(open), setOpen: open.set }
}
